module.exports = __webpack_public_path__ + "img/ppt.0c864f6e.png";